import React from 'react';
import './ImageTooBigPopup.css';

/**
 * 🎨 IMAGE TOO BIG POPUP 2025
 * 
 * Freundliches Modal für File-Size-Warnungen:
 * - Glassmorphism Design
 * - Hilfreiche Tipps zur Komprimierung
 * - Brand-konforme Farben
 * - User-freundliche Darstellung
 */
function ImageTooBigPopup({ 
    isOpen, 
    onClose, 
    fileSize, 
    fileName = 'your image',
    maxSize = 2 
}) {
    if (!isOpen) return null;

    const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(1);

    return (
        <div className="image-too-big-overlay" onClick={onClose}>
            <div className="image-too-big-modal" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="image-too-big-header">
                    <div className="image-too-big-icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2"/>
                            <path d="M16 10v8M16 22v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <h3 className="image-too-big-title">Image Too Large</h3>
                    <button 
                        className="image-too-big-close"
                        onClick={onClose}
                        title="Close"
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="image-too-big-content">
                    <div className="image-too-big-info">
                        <div className="file-info">
                            <div className="file-info-item">
                                <span className="file-info-label">File name:</span>
                                <span className="file-info-value">{fileName}</span>
                            </div>
                            <div className="file-info-item">
                                <span className="file-info-label">Current size:</span>
                                <span className="file-info-value size-current">{fileSizeMB} MB</span>
                            </div>
                            <div className="file-info-item">
                                <span className="file-info-label">Maximum allowed:</span>
                                <span className="file-info-value size-max">{maxSize} MB</span>
                            </div>
                        </div>
                    </div>

                    <div className="image-too-big-suggestions">
                        <h4>💡 How to fix this:</h4>
                        <ul className="suggestions-list">
                            <li>
                                <strong>Compress your image</strong> using online tools like Squoosh
                            </li>
                            <li>
                                <strong>Reduce image dimensions</strong> - most images work great at 1200px width
                            </li>
                            <li>
                                <strong>Convert to WebP or JPEG</strong> format for better compression
                            </li>
                            <li>
                                <strong>Use image editing software</strong> to optimize quality vs file size
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Footer */}
                <div className="image-too-big-footer">
                    <button 
                        className="image-too-big-btn-secondary"
                        onClick={onClose}
                    >
                        Choose Different Image
                    </button>
                    <button 
                        className="image-too-big-btn-primary"
                        onClick={() => {
                            window.open('https://squoosh.app', '_blank');
                            onClose();
                        }}
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M7 1V9M4 4L7 1L10 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Compress Image
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ImageTooBigPopup;
